import { config } from '@tshared/config/config'

import req from './req.pub'

export default {
  fetch: req,
  baseUrl: config.getApiBase(),
}
